import React, { useImperativeHandle, forwardRef } from "react";
import PropTypes from "kf-proptypes/widgets";

import { USER_KIND } from "base/constants";

import { UserCard } from "@widgets/datadisplay/index.jsx";

import styles from "./styles.css";

Mention.propTypes = {
  node: PropTypes.shape({
    Kind: PropTypes.string,
    Id: PropTypes.string,
    Name: PropTypes.string,
    className: PropTypes.string
  }),
  hiddenTypes: PropTypes.arrayOf(PropTypes.string)
};

function Mention(props, ref) {
  useImperativeHandle(ref, () => {
    return {
      getData: () => {
        return props.node;
      }
    };
  });
  if (props.node.Kind === USER_KIND.USER) {
    return (
      <UserCard
        userId={props.node?.Id}
        name={props.node?.Name}
        hiddenTypes={props.hiddenTypes}
      >
        <span
          style={{ cursor: "pointer" }}
          className={`${props.node.className} ${styles.usermention}`}
        >
          {props.node.Name}
        </span>
      </UserCard>
    );
  }
  return (
    <span
      style={{ cursor: "pointer" }}
      className={`${props.node.className} ${styles.usermention}`}
    >
      {props.node.Name}
    </span>
  );
}

export const CustomMention = forwardRef(Mention);
